import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import DialogSelect from "../../components/dialog/dialog";
import { useRouter } from "../routes/hooks/use-router";
import useResultStore from "../../store/result-store";
import usePreviewStore from "../../store/preview-store";
import useOrderStore from "../../store/order-store";
import useModelStore from "../../store/model-store";
import useResponsiveStore from "../../store/responsive-store";
import useSuccessModelStore from "../../store/success-store";
import Success from "../../components/success/success";

const DemoCard = ({ isView, leadDetail,reload }) => {
  const router = useRouter();
  const { resultData, setFormData } = useResultStore();
  const { reset: resetPreview } = usePreviewStore();
  const { reset: resetOrder } = useOrderStore();
  const { reset: resetResult } = useResultStore();
    const { modelData, setModelData,resetModel } = useModelStore();
    const { responsiveData } = useResponsiveStore();
    const { successModalData,setSuccessModalData } = useSuccessModelStore();

  const handleInputChange2 = (e) => {
    setFormData({
      ...resultData,
      lastPrice: e.target.value,
    });
  };
  return (
    <div
      className="k-rounded-lg k-elevation-1 k-p-4 k-mb-4 k-cursor-pointer"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      <h2 className="k-font-light k-m-0 k-pt-4 k-text-uppercase">Demo Info:</h2>
      <div className="">
        <div className="k-mt-4">
          <Label className="k-font-bold">Last Price Quoted:</Label>
        </div>
        <Input
          className="k-md-w-auto"
          type="number"
          value={resultData.lastPrice}
          onChange={handleInputChange2}
          style={{ width: "350px", marginTop: "10px" }}
        />
      </div>
      {/* {leadDetail?.resulted ? (
        <div className="k-display-flex k-justify-content-end k-my-4">
          <Button
            onClick={() =>
              router.push(
                leadDetail?.orderSheet
                  ? `/scan-preview/${leadDetail?._id}?hasSheet=true&leadId=${leadDetail?.leadId}`
                  : `/preview/${leadDetail._id}?hasSheet=true&leadId=${leadDetail.leadId}`
              )
            }
            primary={true}
            className="k-button-green k-mr-2"
            size="large"
          >
            {leadDetail?.orderSheet ? "View Order Sheet" : "View Gutter Sheet"}
          </Button>
        </div>
      ) : ( */}
        <div className="k-display-flex k-justify-content-end k-my-4">
          {/* <Button  primary={true} className="k-button-darkBlue k-mr-2" size="large">
          View Quote
        </Button> */}
          <Button
            primary={true}
            className="k-button-darkBlue k-mr-2"
            size={responsiveData.isMobile ? "small" : "large"}

          >
            Build Job
          </Button>
          <Button
            onClick={() => {
              resetPreview();
              resetOrder();
              setModelData({...modelData,open:!modelData.open})
            }}
            primary={true}
            className={leadDetail?.mhalt ? "k-button-green" : "k-button-darkBlue"}
            size={responsiveData.isMobile ? "small" : "large"}
          >
            mHalt
          </Button>
        </div>
      {/* )} */}
      {modelData.open && leadDetail && (
        <DialogSelect
          visible={modelData.open}
          toggleDialog={() => {
            resetModel()
          }}
          reload={reload}
          leadDetail={leadDetail}
        />
      )}
        {successModalData.open && (
              <Success
                visible={successModalData.open}
                toggleDialog={() => setSuccessModalData({open:false})}
              />
            )}
    </div>
  );
};

export default DemoCard;
